import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import './OnbordingForm.css'
import { api } from '../services/api'

function Onbording() {
  const navigate = useNavigate()
  const [currentStep, setCurrentStep] = useState(1)
  const [currentImageSet, setCurrentImageSet] = useState(0)
  const [isChanging, setIsChanging] = useState(false)
  const professions = [
    'Technology & IT',
    'Creative Arts & Design',
    'Media & Entertainment',
    'Sports & Fitness',
    'Hospitality & Tourism',
    'Retail & E-commerce',
    'Manufacturing & Engineering',
    'Education',
    'Legal & Consultancy',
    'Science & Research',
    'Transportaion & Logistics',
    'Entrepreneurship',
    'Marketing & Advertising',
    'Environmental & Sustainaibility',
    'Pharmaceuticals & Biotechnology'
  ]
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    gender: '',
    dob: '',
    postalCode: '',
    country: '',
    state: '',
    city: '',
    photos: [],
    aboutMe: '',
    jobTitle: '',
    instagramHandle: ''
    
  })
  const [photoFiles, setPhotoFiles] = useState([])
  const [profilePictureIndex, setProfilePictureIndex] = useState(0)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [submitError, setSubmitError] = useState('')
  const [showSuccessPopup, setShowSuccessPopup] = useState(false)
  const [successMessage, setSuccessMessage] = useState('')
  const [fieldErrors, setFieldErrors] = useState({})
  const [countries, setCountries] = useState([])
  const [states, setStates] = useState([])
  const [cities, setCities] = useState([])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
    if (fieldErrors[name]) {
      setFieldErrors((prev) => ({ ...prev, [name]: '' }))
    }
  }

  const handleDobChange = (e) => {
    const { value } = e.target
    setFormData(prev => ({ ...prev, dob: value }))
    if (fieldErrors.dob) {
      setFieldErrors((prev) => ({ ...prev, dob: '' }))
    }
  }
  const handleCountryChange = (e) => {
    const { value } = e.target
    setFormData(prev => ({ ...prev, country: value, state: '', city: '' }))
    if (fieldErrors.country || fieldErrors.state || fieldErrors.city) {
      setFieldErrors((prev) => ({ ...prev, country: '', state: '', city: '' }))
    }
  }

  const handleStateChange = (e) => {
    const { value } = e.target
    setFormData(prev => ({ ...prev, state: value, city: '' }))
    if (fieldErrors.state || fieldErrors.city) {
      setFieldErrors((prev) => ({ ...prev, state: '', city: '' }))
    }
  }

  const handlePhotoUpload = (e, index) => {
    const file = e.target.files[0]
    if (file) {
      setPhotoFiles((prev) => {
        const nextFiles = [...prev]
        nextFiles[index] = file
        return nextFiles
      })
      const reader = new FileReader()
      reader.onloadend = () => {
        const newPhotos = [...formData.photos]
        newPhotos[index] = reader.result
        setFormData(prev => ({ ...prev, photos: newPhotos }))
      }
      reader.readAsDataURL(file)
    }
  }

  const handleNext = () => {
    if (currentStep < 4) {
      if (currentStep === 1) {
        const nextErrors = {}
        if (!formData.firstName.trim()) nextErrors.firstName = 'Please fill this field'
        if (!formData.lastName.trim()) nextErrors.lastName = 'Please fill this field'
        if (!formData.gender) nextErrors.gender = 'Please fill this field'
        if (!formData.dob) nextErrors.dob = 'Please fill this field'
        if (!formData.postalCode.trim()) nextErrors.postalCode = 'Please fill this field'
        if (!formData.country) nextErrors.country = 'Please fill this field'
        if (!formData.state) nextErrors.state = 'Please fill this field'
        if (!formData.city) nextErrors.city = 'Please fill this field'
        setFieldErrors(nextErrors)
        if (Object.keys(nextErrors).length > 0) return
      }
      setCurrentStep(currentStep + 1)
    }
  }

  const handleBack = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1)
    }
  }

  const handleSkip = () => {
    if (currentStep < 4) {
      setCurrentStep(currentStep + 1)
    }
  }

  const handleSubmit = async () => {
    setSubmitError('')
    setShowSuccessPopup(false)
    setSuccessMessage('')
    setIsSubmitting(true)
    try {
      const selectedFiles = photoFiles.filter(Boolean)
      let uploadedImages = []

      if (selectedFiles.length > 0) {
        const uploadResponse = await api.uploadOnboardingImages(selectedFiles)
        uploadedImages = uploadResponse?.images || []
      }

      const profilePicture =
        uploadedImages[profilePictureIndex] || uploadedImages[0] || undefined

      const payload = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        dob: formData.dob,
        gender: formData.gender,
        country: formData.country,
        state: formData.state,
        city: formData.city,
        profession: formData.jobTitle,
        bio: formData.aboutMe,
        profilePicture,
        images: uploadedImages
      }

      await api.onboardUser(payload)
      setSuccessMessage('Form submitted successfully!')
      setShowSuccessPopup(true)
    } catch (error) {
      setSubmitError(error.message || 'Unable to submit onboarding data.')
      setShowSuccessPopup(true)
    } finally {
      setIsSubmitting(false)
    }
  }

  // Multiple sets of sample user images
  const imageSets = [
    [
      { src: require('../assets/images/Gurmeetsingh.png'), className: 'image-pos-0', name: 'Gurmeet' },
      { src: require('../assets/images/HimanshiNegi.png'), className: 'image-pos-1', name: 'Himanshi' },
      { src: require('../assets/images/VarunSharma.png'), className: 'image-pos-2', name: 'Varun' },
      { src: require('../assets/images/KritikaRanta.png'), className: 'image-pos-3', name: 'Kritika' },
      { src: require('../assets/images/KiranKaur.png'), className: 'image-pos-4', name: 'Kiran' },
      { src: require('../assets/images/HarmanpreetSingh.png'), className: 'image-pos-5', name: 'Harmanpreet' },
      { src: require('../assets/images/MansiVerma.png'), className: 'image-pos-6', name: 'Mansi' },
      { src: require('../assets/images/JatinBansal.png'), className: 'image-pos-7', name: 'Jatin' },
      { src: require('../assets/images/PriyankaSharma.png'), className: 'image-pos-8', name: 'Priyanka' },
      { src: require('../assets/images/RahilSahni.png'), className: 'image-pos-9', name: 'Rahil' }
    ],
    [
      { src: require('../assets/images/ArpanThapa.png'), className: 'image-pos-0', name: 'Arpan' },
      { src: require('../assets/images/SonaliSharma.png'), className: 'image-pos-1', name: 'Sonali' },
      { src: require('../assets/images/VishalSharma.png'), className: 'image-pos-2', name: 'Vishal' },
      { src: require('../assets/images/AnkitaMittal.png'), className: 'image-pos-3', name: 'Ankita' },
      { src: require('../assets/images/DevanshSharma.png'), className: 'image-pos-4', name: 'Devansh' },
      { src: require('../assets/images/SaviBali.png'), className: 'image-pos-5', name: 'Savi' },
      { src: require('../assets/images/RahilSahni.png'), className: 'image-pos-6', name: 'Rahil' },
      { src: require('../assets/images/RitikaSharma.png'), className: 'image-pos-7', name: 'Ritika' },
      { src: require('../assets/images/ShivaniSingh.png'), className: 'image-pos-8', name: 'Shivani' },
            { src: require('../assets/images/KritikaRanta.png'), className: 'image-pos-9', name: 'Kritika' },

    ],
    [
      { src: require('../assets/images/Karan.png'), className: 'image-pos-0', name: 'Karan' },
      { src: require('../assets/images/Shalini.png'), className: 'image-pos-1', name: 'Shalini' },
      { src: require('../assets/images/JatindraSingh.png'), className: 'image-pos-2', name: 'Jatindra' },
      { src: require('../assets/images/SoniaPundir.png'), className: 'image-pos-3', name: 'Sonia' },
      { src: require('../assets/images/SagarSingh.png'), className: 'image-pos-4', name: 'Sagar' },
      { src: require('../assets/images/KaranveerSingh.png'), className: 'image-pos-5', name: 'Karanveer' },
      { src: require('../assets/images/asifkhan.png'), className: 'image-pos-6', name: 'Asif' },
      { src: require('../assets/images/a.jpg'), className: 'image-pos-7', name: 'Aarav' },
      { src: require('../assets/images/b.jpg'), className: 'image-pos-8', name: 'Neha' },
            { src: require('../assets/images/RitikaSharma.png'), className: 'image-pos-9', name: 'Ritika' },

    ]
  ]

  const sampleImages = imageSets[currentImageSet]

  // Auto-rotate all images every 5 seconds with smooth transition
  useEffect(() => {
    const interval = setInterval(() => {
      setIsChanging(true)
      
      setTimeout(() => {
        setCurrentImageSet((prev) => (prev + 1) % imageSets.length)
        setTimeout(() => {
          setIsChanging(false)
        }, 600)
      }, 300)
    }, 5000)

    return () => clearInterval(interval)
  }, [])

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await fetch('https://api-csc.indraq.info/api/countries')
        const data = await response.json()
        const list = Array.isArray(data) ? data : (Array.isArray(data?.data) ? data.data : [])
        setCountries(list)
      } catch (error) {
        console.error('Failed to load countries', error)
      }
    }

    fetchCountries()
  }, [])

  useEffect(() => {
    if (!formData.country) {
      setStates([])
      setCities([])
      return
    }

    const fetchStates = async () => {
      try {
        const response = await fetch(`https://api-csc.indraq.info/api/states?country_name=${encodeURIComponent(formData.country)}`)
        const data = await response.json()
        const list = Array.isArray(data) ? data : (Array.isArray(data?.data) ? data.data : [])
        setStates(list)
      } catch (error) {
        console.error('Failed to load states', error)
      }
    }

    fetchStates()
  }, [formData.country])

  useEffect(() => {
    if (!formData.country || !formData.state) {
      setCities([])
      return
    }

    const fetchCities = async () => {
      try {
        const response = await fetch(
          `https://api-csc.indraq.info/api/cities?country_name=${encodeURIComponent(formData.country)}&state_name=${encodeURIComponent(formData.state)}`
        )
        const data = await response.json()
        const list = Array.isArray(data) ? data : (Array.isArray(data?.data) ? data.data : [])
        setCities(list)
      } catch (error) {
        console.error('Failed to load cities', error)
      }
    }

    fetchCities()
  }, [formData.country, formData.state])

  return (
    <>
      <div className="onboarding-container">
        <div className="onboarding-content">
          <div className="onboarding-left">
            {/* Progress Indicator */}
            <div className="progress-indicator">
              {[1, 2, 3, 4].map((step) => (
                <React.Fragment key={step}>
                  <div className={`step-circle ${currentStep === step ? 'current' : ''}`}>
                    {step}
                  </div>
                  {step < 4 && <div className="step-line" />}
                </React.Fragment>
              ))}
            </div>

            <h2 className="onboarding-title">
              Please help us with few things to get you verified and started
            </h2>

            {/* Back Button */}
            {currentStep > 1 && (
              <button className="back-button" onClick={handleBack}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M15 18L9 12L15 6" stroke="#EF9273" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            )}

            {/* Step 1: Basic Information */}
            {currentStep === 1 && (
              <div className="form-step">
                <div className="form-row">
                  <div className="form-field">
                    <input
                      type="text"
                      name="firstName"
                      placeholder="First Name"
                      value={formData.firstName}
                      onChange={handleInputChange}
                      className="form-inpute"
                    />
                    {fieldErrors.firstName && <span className="field-error">{fieldErrors.firstName}</span>}
                  </div>
                  <div className="form-field">
                    <input
                      type="text"
                      name="lastName"
                      placeholder="Last Name"
                      value={formData.lastName}
                      onChange={handleInputChange}
                      className="form-inpute"
                    />
                    {fieldErrors.lastName && <span className="field-error">{fieldErrors.lastName}</span>}
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-field">
                    <select
                      name="gender"
                      value={formData.gender}
                      onChange={handleInputChange}
                      className="form-select"
                    >
                      <option value="">Gender</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                      <option value="other">Other</option>
                    </select>
                    {fieldErrors.gender && <span className="field-error">{fieldErrors.gender}</span>}
                  </div>
                  <div className="form-field">
                    <input
                      type="date"
                      name="dob"
                      placeholder='Dob'
                      value={formData.dob}
                      onChange={handleDobChange}
                      className="form-inpute"
                      max={new Date().toISOString().split('T')[0]}
                    />
                    {fieldErrors.dob && <span className="field-error">{fieldErrors.dob}</span>}
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-field">
                    <input
                      type="text"
                      name="postalCode"
                      placeholder="Postal Code"
                      value={formData.postalCode}
                      onChange={handleInputChange}
                      className="form-inpute"
                    />
                    {fieldErrors.postalCode && <span className="field-error">{fieldErrors.postalCode}</span>}
                  </div>
                  <div className="form-field">
                    <select
                      name="country"
                      value={formData.country}
                      onChange={handleCountryChange}
                      className="form-select"
                    >
                      <option value="">Country</option>
                      {countries.map((country) => (
                        <option key={country.id || country.name} value={country.name}>
                          {country.name}
                        </option>
                      ))}
                    </select>
                    {fieldErrors.country && <span className="field-error">{fieldErrors.country}</span>}
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-field">
                    <select
                      name="state"
                      value={formData.state}
                      onChange={handleStateChange}
                      className="form-select"
                    >
                      <option value="">State</option>
                      {states.map((state) => (
                        <option key={state.id || state.name} value={state.name}>
                          {state.name}
                        </option>
                      ))}
                    </select>
                    {fieldErrors.state && <span className="field-error">{fieldErrors.state}</span>}
                  </div>
                  <div className="form-field">
                    <select
                      name="city"
                      value={formData.city}
                      onChange={handleInputChange}
                      className="form-select"
                    >
                      <option value="">City</option>
                      {cities.map((city) => (
                        <option key={city.id || city.name} value={city.name}>
                          {city.name}
                        </option>
                      ))}
                    </select>
                    {fieldErrors.city && <span className="field-error">{fieldErrors.city}</span>}
                  </div>
                </div>

                <button className="next-button single-next" onClick={handleNext}>
                  Next
                </button>
              </div>
            )}

            {/* Step 2: Photo Upload */}
            {currentStep === 2 && (
              <div className="form-step">
                <p className="step-instruction">Please upload at least 3 photos</p>
                
                <div className="photo-upload-container">
                  {[0, 1, 2].map((index) => (
                    <div key={index} className="photo-upload-box">
                      <input
                        type="file"
                        id={`photo-${index}`}
                        accept="image/*"
                        onChange={(e) => handlePhotoUpload(e, index)}
                        style={{ display: 'none' }}
                      />
                      <label htmlFor={`photo-${index}`} className="photo-upload-label">
                        {formData.photos[index] ? (
                          <img src={formData.photos[index]} alt={`Upload ${index + 1}`} className="uploaded-photo" />
                        ) : (
                          <>
                            <span className="plus-icon">+</span>
                          </>
                        )}
                      </label>
                      <label className="photo-check">
                        <input
                          type="checkbox"
                          className="photo-checkbox"
                          checked={profilePictureIndex === index}
                          onChange={() => setProfilePictureIndex(index)}
                        />
                        <span>Make Profile Picture</span>
                      </label>
                    </div>
                  ))}
                </div>

                <div className="about-me-section">
                  <label className="about-label">About Me</label>
                  <textarea
                    name="aboutMe"
                    placeholder="Atleast 50 Words"
                    value={formData.aboutMe}
                    onChange={handleInputChange}
                    className="about-textarea"
                    rows="5"
                  />
                </div>

                <div className="button-group">
                  <button className="skip-button" onClick={handleSkip}>
                    Skip
                  </button>
                  <button className="next-button" onClick={handleNext}>
                    Next
                  </button>
                </div>
              </div>
            )}

            {/* Step 3: Professional Information */}
            {currentStep === 3 && (
              <div className="form-step">
                <p className="step-instruction">What do you do in your daily life ?</p>
                
                <select
                  name="jobTitle"
                  value={formData.jobTitle}
                  onChange={handleInputChange}
                  className="form-select full-width"
                >
                  <option value="">Select Profession</option>
                  {professions.map((profession) => (
                    <option key={profession} value={profession}>
                      {profession}
                    </option>
                  ))}
                </select>

                <div className="button-group">
                  <button className="skip-button" onClick={handleSkip}>
                    Skip
                  </button>
                  <button className="next-button" onClick={handleNext}>
                    Next
                  </button>
                </div>
              </div>
            )}

            {/* Step 4: Identity Verification */}
            {currentStep === 4 && (
              <div className="form-step">
                <p className="step-instruction">Help us verify your Identity please</p>
                
                <input
                  type="text"
                  name="instagramHandle"
                  placeholder="Instagram Handle"
                  value={formData.instagramHandle}
                  onChange={handleInputChange}
                  className="form-inpute full-width"
                />

                {/* <input
                  type="text"
                  name="linkedinUrl"
                  placeholder="Linkedin Profile URL"
                  value={formData.linkedinUrl}
                  onChange={handleInputChange}
                  className="form-inpute full-width"
                /> */}

                <div className="button-group">
                  {/* <button className="skip-button" onClick={handleSkip}>
                    Skip
                  </button> */}
                  <button
                    className="submit-button"
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Submitting...' : 'Submit'}
                  </button>
                </div>
                {submitError && <p className="submit-error">{submitError}</p>}
              </div>
            )}
          </div>

          {/* Right Side - Sample Images */}
          <div className="onboarding-right">
            <div className="sample-images-collage">
              <div className="featured-box">
                <p className="featured-text">Users who found<br/>love through<br/><span className="highlight">Mulaqaat by<br/>The Event House</span></p>
              </div>
              {sampleImages.map((img, idx) => (
                <div key={idx} className={`sample-image-box ${img.className}`}>
                  <div className="sample-image-frame">
                    <img 
                      src={img.src} 
                      alt={`User ${idx + 1}`}
                      className={isChanging ? 'changing' : ''}
                    />
                  </div>
                  <span className="sample-image-name">{img.name}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {showSuccessPopup && (
        <div className="onboarding-success-overlay" onClick={() => setShowSuccessPopup(false)}>
          <div className="onboarding-success-modal" onClick={(event) => event.stopPropagation()}>
            <h3>{submitError ? 'Error' : 'Success'}</h3>
            <p>{submitError || successMessage}</p>
            <button
              type="button"
              className="onboarding-success-ok"
              onClick={() => {
                setShowSuccessPopup(false)
                if (!submitError) {
                  navigate('/dashboard')
                }
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </>
  )
}

export default Onbording
